import http from '@/plugins/axios';
import { sync } from 'vuex-router-sync';

export async function code_login(payload) {
  const response = await http.post(`customer/code-login`, payload);
  return response.data;

}
export async function log_out() {
  const response = await http.post(`logout`);
  return response.data;
}

export async function get_profile() {
  const response = await http.post(`account-detail`);
  return response.data;
}
export async function login_by_id(payload) {
  const response = await http.post(`login`, { short_token: payload });
  return response.data;
}

export async function update_phone_number(payload) {
  const response = await http.post(`update/phone`, payload);
  return response.data;
}



